export interface DomainListResponse {
    isActionSuccess: boolean;
    data: {
        domains: string[];
    }
}
export interface pageObject {
  pageNum: number,
  selected: boolean,
}

export interface DomainOption {
  value: string;
  label: string;
}

export interface UnsubscribeRecord {
  id: string;
  contactInfo: string;
  unsubscribedFrom: string;
  unsubscribeTime: string;
  campaignName: string;
  canResubscribe: boolean;
  resubscribeRestrictionReason:string;
}

export interface UnsubscribeData {
  totalCount: number;
  records: UnsubscribeRecord[];
  pageNumber: number;
}

export interface UnsubscribeResponse {
  isActionSuccess: boolean;
  errors: any | null;
  data: UnsubscribeData;
}
export interface recordsDataInterface {
  totalRows : number;
  invalidRows : number;
  duplicateRows : number;
  uniqueEmailCount : number;
  uniquePhoneNumberCount : number;
  totalFinalRecords : number;
  actualValidRows : number;
}

export const defaultRecordData : recordsDataInterface= {
  totalRows : 0,
  invalidRows : 0,
  duplicateRows : 0,
  uniqueEmailCount : 0,
  uniquePhoneNumberCount : 0,
  totalFinalRecords : 0,
  actualValidRows : 0
}

export interface pageObject {
  pageNum: number,
  selected: boolean,
}

export interface RecordData {
  IndexNo: string;
  "Email Address": string;
  "Phone Number": string;
  isDuplicate: boolean;
}
export interface listObject {
  list: RecordData[];
  count: number;
  limit: number;
  pageNumber: number;
}

export interface DataMapping {
  sno: string;
  column: string;
  fileColumn: string;
  expectedColumn: string;
  currentSelectedValue: string;
}
